import axios from 'Lib/http'

// 患者和就诊人信息模块
const state = {
  commpatList: [], // 常用就诊人列表
  hostList: [], // 医院列表
  currHosIndex: 0, // 选择当前医院的下标
  currCommpatIndex: 0 // 选择当前就诊人的下标
}

const mutations = {
  // 修改患者和就诊人信息
  setPatient (state, obj) {
    state.patientInfo = obj
  },
  // 修改常用就诊人列表
  setCommpatList (state, list) {
    state.commpatList = list
  },
  // 设置常用就诊人下标为index项
  setCommpatItem (state, {index, item}) {
    state.commpatList[index] = item
  },
  // 修改医院列表
  setHostList (state, list) {
    state.hostList = list
  },
  // 设置选中当前医院下标
  setCurrHosIndex (state, currHosIndex) {
    state.currHosIndex = currHosIndex
  },
  // 设置选中当前患者下标
  setCurrCommpatIndex (state, currCommpatIndex) {
    state.currCommpatIndex = currCommpatIndex
  }
}

const getters = {
  // 根据选中就诊人下标获取信息
  userCommonPatVo: state => state.commpatList.find((item, index) => index === state.currCommpatIndex) || {},
  // 当前医院
  currHos: state => state.hostList[state.currHosIndex] || {},
  // 当前就诊卡号
  currJzkh: (state, getters) => {
    let userCommonPatRecord = getters.userCommonPatVo && getters.userCommonPatVo.userCommonPatRecords && getters.userCommonPatVo.userCommonPatRecords.find(item => item.yyid === getters.currHos.yyid) || {}
    return userCommonPatRecord.hosPatid
  }
}

const actions = {
  // 给每个item设置就诊卡号
  async setHosPatid ({commit}, {item, index}) {
    // 根据患者id同步查询绑定就诊卡列表
    let {code, list, msg} = await axios('smarthos.yygh.ApiPatientService.selectHosAndHosPatid', {
      hzid: item.patId,
      patvisitId: item.id
    })
    if (code === '0') {
      item.userCommonPatRecords = list
      commit('setCommpatItem', {item, index})
    } else {
      bus.$emit('msg', msg)
    }
  },
  // 查询常用就诊人列表
  async queryCommpatList ({ dispatch, commit }) {
    let { code, list, msg } = await axios('smarthos.user.commpat.list', {})
    if (code === '0') {
      commit('setCommpatList', list)
      list.forEach(async (item, index) => {
        await dispatch('setHosPatid', {item, index})
      })
    } else {
      // bus.$emit('msg', msg)
    }
  },
  // 查询医院列表
  async queryHosList ({ commit }) {
    let { code, list, msg } = await axios('smarthos.yygh.ApiPlatBaseService.areaHosList', {})
    if (code === '0') {
      commit('setHostList', list)
    } else {
      bus.$emit('msg', msg)
    }
  }
}

// 查询患者下面所有的就诊人病案号
const findPatidList = async () => {
  await axios('smarthos.yygh.ApiPatientService.findPatidList', {
    hosId: '',
    patid: '',
    patvisitIds: []
  })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js